import { Component, OnInit, inject, input } from '@angular/core';
import { CartPosition } from 'src/app/common/CartPosition';
import {
  OrderPositionValidationError,
  orderValidationReasonText,
} from 'src/app/common/OrderValidation';
import { FileService } from 'src/app/services/file.service';
import { EditCartItemComponent } from '../edit-cart-item/edit-cart-item.component';
import { CommonModule } from '@angular/common';

@Component({
    imports: [CommonModule, EditCartItemComponent],
    selector: 'app-cart-item',
    templateUrl: './cart-item.component.html',
    styleUrls: ['./cart-item.component.css']
})
export class CartItemComponent implements OnInit {
  private fileService = inject(FileService);

  readonly cartItem = input<CartPosition>();

  // Backend #507 (G2): this line's rejection from the last checkout attempt (422 order
  // gate), if any. Takes display precedence over the cart read's unavailableReason flag —
  // it is the more specific, attempt-scoped message (e.g. carries stock counts).
  readonly orderError = input<OrderPositionValidationError>();
  public image: any;

  ngOnInit(): void {
    this.cartItem().files.forEach((f) => this.fileService.createImageFromBase64(f));
  }

  // Backend #507 (G1/G2): one warning text per line — the checkout rejection if present,
  // otherwise the cart read's own unavailability flag ('notFound'/'inactive'), else null.
  public get unavailableText(): string | null {
    const orderError = this.orderError();
    if (orderError) {
      return orderValidationReasonText(orderError);
    }
    const cartItem = this.cartItem();
    if (cartItem.unavailableReason) {
      return orderValidationReasonText({ reason: cartItem.unavailableReason });
    }
    return null;
  }
}
